import { Hidden, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";

export default function TransactionTableHeader({ isFullTable = true }) {
  return (
    <TableHead>
      <TableRow>
        <TableCell colSpan={2}>
          <Typography>Type</Typography>
        </TableCell>
        <TableCell colSpan={3}>
          <Typography>Date time</Typography>
        </TableCell>
        <TableCell colSpan={2}>
          <Typography>Amount(USD)</Typography>
        </TableCell>
        {isFullTable && (
          <>
            <Hidden mdDown>
              <TableCell colSpan={2}>
                <Typography>Token</Typography>
              </TableCell>
              <TableCell colSpan={2}>
                <Typography>Transaction</Typography>
              </TableCell>
            </Hidden>
            <Hidden lgUp>
              <TableCell colSpan={1}></TableCell>
            </Hidden>
          </>
        )}
      </TableRow>
    </TableHead>
  );
}
